// extracted by mini-css-extract-plugin
module.exports = {"footer":"MutateMid_footer__2Qhsx","legacyBtn":"MutateMid_legacyBtn__x0HQL"};